import * as ACTION_TYPES from './Types';

const initialState = {
  warehousedata: {},
  warehouseProductData: {},
  cityDetails: {},
  message: '',
  error: null,
}

export const warehouseReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.GETWAREHOUSE_SUCCESS:
      return {
        ...state,
        warehousedata: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETWAREHOUSE_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETCITY_SUCCESS:
      return {
        ...state,
        cityDetails: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETCITY_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }


    case ACTION_TYPES.GETWAREHOUSEPRODUCT_SUCCESS:
      return {
        ...state,
        warehouseProductData: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETWAREHOUSEPRODUCT_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }


    case ACTION_TYPES.ADDWAREHOUSE_SUCCESS:
    case ACTION_TYPES.UPDATEWAREHOUSE_SUCCESS:
    case ACTION_TYPES.DELETEWAREHOUSE_SUCCESS:
      return {
        ...state,
        warehouse: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDWAREHOUSE_ERROR:
    case ACTION_TYPES.UPDATEWAREHOUSE_ERROR:
    case ACTION_TYPES.DELETEWAREHOUSE_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
